/**
* Form Validator Directive
* @todo make this a class
*/

function formValidator() {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope:{'onChange':'=' },
        link: function(scope, element, attrs, ctrl)
        {
            //Clean invalid confirmation
            element.on("change",function() {
                ctrl.$setValidity('server', true);
            });
        }
    };
}
export default angular.module('formValidator', []).directive('formValidator', formValidator).name;


/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/formValidator.directive.js
 **/